import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { actressApi, apiConfig } from '../utils/apiConfig';

const ActressList = () => {
  const [actresses, setActresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isMockData, setIsMockData] = useState(false);

  useEffect(() => {
    const fetchActresses = async () => {
      try {
        setLoading(true);
        setIsMockData(apiConfig.isUsingMockData());
        
        const response = await actressApi.getAll({ page, limit: 10 });
        
        // Handle different response formats (mock vs real API)
        const data = response.data;
        if (data.data) {
          // Mock API format
          setActresses(data.data);
          setTotalPages(data.pagination?.totalPages || 1);
        } else {
          // Real API format
          setActresses(data.actresses || []);
          setTotalPages(data.pagination?.totalPages || 1);
        }
        
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch actresses');
        setLoading(false);
        console.error(err);
      }
    };

    fetchActresses();
  }, [page]);

  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (page < totalPages) {
      setPage(page + 1);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="actress-list">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-bold">女優一覧</h2>
        {isMockData && (
          <span className="bg-orange-100 text-orange-700 px-3 py-1 rounded-full text-sm font-medium">
            🧪 仮データ表示中
          </span>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {actresses.map((actress) => (
          <div key={actress.id} className="actress-card border rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow relative">
            {actress.isMock && (
              <div className="absolute top-2 right-2">
                <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-xs font-medium">
                  🧪 Mock
                </span>
              </div>
            )}
            <Link to={`/actresses/${actress.id}`}>
              <div className="flex items-center">
                {actress.profileImage ? (
                  <img 
                    src={actress.profileImage} 
                    alt={actress.name} 
                    className="w-16 h-16 rounded-full object-cover mr-4"
                  />
                ) : (
                  <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center mr-4">
                    <span className="text-gray-500 text-xs">No Image</span>
                  </div>
                )}
                <div className="flex-1">
                  <h3 className="text-lg font-semibold">{actress.name}</h3>
                  {actress.japaneseName && (
                    <p className="text-sm text-gray-600">{actress.japaneseName}</p>
                  )}
                  {actress.birthdate && (
                    <p className="text-xs text-gray-500">生年月日: {actress.birthdate}</p>
                  )}
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
      
      {actresses.length === 0 && (
        <div className="text-center py-8">
          <p>No actresses found</p>
        </div>
      )}
      
      <div className="pagination flex justify-center mt-6">
        <button 
          onClick={handlePrevPage} 
          disabled={page === 1}
          className="px-4 py-2 mr-2 bg-gray-200 rounded disabled:opacity-50"
        >
          Previous
        </button>
        <span className="px-4 py-2">
          Page {page} of {totalPages}
        </span>
        <button 
          onClick={handleNextPage} 
          disabled={page === totalPages}
          className="px-4 py-2 ml-2 bg-gray-200 rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ActressList;
